export default __webpack_public_path__ + "static/media/1.49ad3392.jpg";